/**
 * Utility functions for detecting test environments
 */
declare global {
  interface Window {
    playwright?: boolean;
    playwrightFastPolling?: boolean;
  }
}

/** True when MSW's auth bypass has run — i.e. any mock session, demo or test. */
export function isTestEnvironment(): boolean {
  return !!window.playwright;
}

/**
 * Whether the page explicitly asked for test-speed polling.
 *
 * Separate from `isTestEnvironment` because `window.playwright` no longer means "a test
 * is running" — MSW's auth bypass sets it in every mock session, including demos and
 * local `#apiEnv=mock`, where a human is watching. `navigator.webdriver` isn't a usable
 * discriminator either (measured false in a CDP-attached Chrome), so this is opt-in:
 * specs that want it set it, nobody else does.
 */
export function isFastPollingRequested(): boolean {
  return !!window.playwrightFastPolling;
}

/**
 * Short interval ONLY when a test asked for it — at 3s the EMT Exceptions list refetched
 * constantly during demos and its "Last updated" label cycled 0,1,2,0.
 */
export function getPollingInterval(normalInterval = 60, testInterval = 3): number {
  return isFastPollingRequested() ? testInterval : normalInterval;
}
